import styled, { css } from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';

type StyledTableProps = {
    striped?: boolean;
} & SpaceProps &
    LayoutProps &
    TypographyProps &
    ColorProps &
    BorderProps &
    PositionProps;

export const StyledTable = styled.table<StyledTableProps>`
    border-collapse: collapse;
    width: 100%;
    margin: 30px 0;
    border: 1px solid ${({ theme }) => theme.colors.table.border};
    box-sizing: border-box;
    font-size: ${({ theme }) => theme.fontSizes[3]};
    font-weight: ${({ theme }) => theme.fontWeights.light};
    color: ${({ theme }) => theme.colors.table.body.text};
    background-color: ${({ theme }) => theme.colors.table.body.background};
    text-align: left;

    ${({ striped, theme }) =>
        striped &&
        css`
            tbody {
                tr:nth-child(even) {
                    background-color: ${theme.colors.table.body.stripedRow};
                }
            }
        `}

    ${space}
  ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}
`;
